export enum EmbedErrorType {
    ContainerNotFoundError = 'container_not_found',
    SiteConfigFetchError = 'site_config_fetch_error',
    InvalidConfigKeyError = 'invalid_config_key',
    InvalidSiteConfigError = 'invalid_site_config',
    SSOAuthError = 'sso_auth_error'
}
